function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useEffect, useState } from "react";
import Address from "./Address";
import { toast } from "react-toastify";
import { toIndianRs } from "../../../../utils/helpers";
import GrClose from "@meronex/icons/gr/GrClose";
import Modal from "../../../Common/Modal";
import useData from "./data";
import useInput from "../../../../Hooks/useInput";
import { RE_NAME, RE_Pin, RE_Phone } from "../../../../constants";
import useBookingSummary from "../../../../Hooks/use-bookingSummary";
import BsArrowLeft from "@meronex/icons/bs/BsArrowLeft";
import { usePhoneInput } from "../../../../Hooks";
import LoadingButton from "../../../Common/LoadingButton";
import Bag from "./Bag";
import DealSection from "../DealSection";
import BasketFull from "../BasketFull";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var interval = null;
function Checkout(_ref) {
  var _redux$auth;
  var config = _ref.config,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router,
    winnreAuth = _ref.winnreAuth,
    winnreNoAuth = _ref.winnreNoAuth,
    cmsClient = _ref.cmsClient,
    appType = _ref.appType,
    isPointsProp = _ref.isPoints,
    _ref$showAppDownload = _ref.showAppDownload,
    showAppDownload = _ref$showAppDownload === void 0 ? false : _ref$showAppDownload;
  var params = (router === null || router === void 0 ? void 0 : router.params) || {};
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    currentStep = _useState2[0],
    setCurrentStep = _useState2[1];
  var history = (router === null || router === void 0 ? void 0 : router.history) || {
    push: function push() {},
    replace: function replace() {},
    goBack: function goBack() {}
  };
  var location = (router === null || router === void 0 ? void 0 : router.location) || {
    search: ""
  };
  var queryParams = new URLSearchParams(location.search);
  var isPoints = queryParams.get("isPoints") === "true" || queryParams.get("isPoints") === "1" || isPointsProp;
  var userHash = redux === null || redux === void 0 || (_redux$auth = redux.auth) === null || _redux$auth === void 0 ? void 0 : _redux$auth.userHash;
  // const [otp, setOtp] = useState(['', '', '', '']);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFormValid = _useState4[0],
    setIsFormValid = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    amountPayable = _useState6[0],
    setAmountPayable = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    totalRedeem = _useState8[0],
    settotalRedeem = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    termsCheckbox = _useState0[0],
    setTermsCheckbox = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    loading = _useState10[0],
    setLoading = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    redirecting = _useState12[0],
    setRedirecting = _useState12[1];
  // const[status,setStatus]=useState(true);
  var _useState13 = useState(""),
    _useState14 = _slicedToArray(_useState13, 2),
    otp = _useState14[0],
    setOtp = _useState14[1];
  var handleOnChange = function handleOnChange() {
    setTermsCheckbox(!termsCheckbox);
  };
  // Cart Counter
  var _useState15 = useState(0),
    _useState16 = _slicedToArray(_useState15, 2),
    cartAmount = _useState16[0],
    setCartAmount = _useState16[1];
  var _useState17 = useState(0),
    _useState18 = _slicedToArray(_useState17, 2),
    cartPoint = _useState18[0],
    setCartPoint = _useState18[1];
  var _useState19 = useState(0),
    _useState20 = _slicedToArray(_useState19, 2),
    shippingFee = _useState20[0],
    setShippingFee = _useState20[1];
  var _useState21 = useState(0),
    _useState22 = _slicedToArray(_useState21, 2),
    platformFee = _useState22[0],
    setPlatformFee = _useState22[1];
  var _useState23 = useState(0),
    _useState24 = _slicedToArray(_useState23, 2),
    cartItems = _useState24[0],
    setCartItems = _useState24[1];
  var _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    cartValue = _useState26[0],
    setCartValue = _useState26[1];
  var _useData = useData({
      userHash: userHash,
      otp: otp,
      setOtp: setOtp,
      redux: redux,
      winnreAuth: winnreAuth,
      cmsClient: cmsClient,
      isPoints: isPoints
    }),
    deals = _useData.deals,
    loadingDeal = _useData.loadingDeal,
    showOtpModal = _useData.showOtpModal,
    setShowOtpModal = _useData.setShowOtpModal,
    getOtp = _useData.getOtp,
    otpLoading = _useData.otpLoading,
    timeLeftToResend = _useData.timeLeftToResend,
    setTimeLeftToResend = _useData.setTimeLeftToResend,
    getOffers = _useData.getOffers;

  //   Handle input change
  var handleChange = function handleChange(e) {
    var value = e.target.value;
    if (/^\d{0,4}$/.test(value)) {
      setOtp(value);
    }
  };
  console.log("otp", otp);
  var _useBookingSummary = useBookingSummary({
      redux: redux,
      winnreAuth: winnreAuth,
      appType: appType,
      isPoints: isPoints
    }),
    userAccountSummary = _useBookingSummary.userAccountSummary;
  var _useState27 = useState(true),
    _useState28 = _slicedToArray(_useState27, 2),
    hideError = _useState28[0],
    setHideError = _useState28[1];
  var _useState29 = useState(0),
    _useState30 = _slicedToArray(_useState29, 2),
    points = _useState30[0],
    setPoints = _useState30[1];
  var _useState31 = useState(0),
    _useState32 = _slicedToArray(_useState31, 2),
    redeemPointsLimit = _useState32[0],
    setRedeemPointsLimit = _useState32[1];
  var _useState33 = useState(null),
    _useState34 = _slicedToArray(_useState33, 2),
    error = _useState34[0],
    setError = _useState34[1];
  var _useState35 = useState({
      address: "",
      locality: "",
      city: "",
      state: ""
    }),
    _useState36 = _slicedToArray(_useState35, 2),
    formData = _useState36[0],
    setFormData = _useState36[1];
  var _useInput = useInput(function (value) {
      return !RE_NAME.test(value) && value !== "";
    }),
    name = _useInput.value,
    nameIsValid = _useInput.isValid,
    nameHasError = _useInput.hasError,
    nameChangedHandler = _useInput.valueChangeHandler,
    nameBlurHandler = _useInput.inputBlurHandler,
    resetName = _useInput.reset;
  var _useInput2 = useInput(function (value) {
      return RE_Pin.test(value);
    }),
    Pin = _useInput2.value,
    PinIsValid = _useInput2.isValid,
    PinHasError = _useInput2.hasError,
    PinChangedHandler = _useInput2.valueChangeHandler,
    PinBlurHandler = _useInput2.inputBlurHandler,
    resetPin = _useInput2.reset;
  var _useInput3 = useInput(function (value) {
      return RE_Phone.test(value);
    }, undefined, hideError, setHideError),
    phoneNumber = _useInput3.value,
    phoneNumberIsValid = _useInput3.isValid,
    phoneHasError = _useInput3.hasError,
    phoneChangedHandler = _useInput3.valueChangeHandler,
    phoneBlurHandler = _useInput3.inputBlurHandler,
    resetPhone = _useInput3.reset;
  var _usePhoneInput = usePhoneInput(),
    _usePhoneInput$state = _usePhoneInput.state,
    mobileNumberIsValid = _usePhoneInput$state.isValid,
    mobile = _usePhoneInput$state.mobile,
    country = _usePhoneInput$state.country,
    mobileHasError = _usePhoneInput$state.mobileHasError,
    isInputFocused = _usePhoneInput$state.isInputFocused,
    isInternationalCustomer = _usePhoneInput$state.isInternationalCustomer,
    onChange = _usePhoneInput.onChange,
    validator = _usePhoneInput.validator,
    setIsTouched = _usePhoneInput.setIsTouched,
    setMobile = _usePhoneInput.setMobile,
    getMobileWithoutCountryCode = _usePhoneInput.getMobileWithoutCountryCode,
    setInputFocused = _usePhoneInput.setInputFocused,
    setIsInternationalCustomer = _usePhoneInput.setIsInternationalCustomer;
  console.log("mobile", mobile);
  console.log("mobileNumber", getMobileWithoutCountryCode());
  console.log("countryCode", country.dialCode);
  console.log("phoneNumber", phoneNumber);
  console.log("currentStep", currentStep);
  useEffect(function () {
    var timer = setTimeout(function () {
      setError(null);
    }, 3000);
    return function () {
      clearTimeout(timer);
    };
  }, [error]);
  useEffect(function () {
    var isValid = false;
    setIsFormValid(isValid);
    if (nameIsValid && mobileNumberIsValid && PinIsValid && formData.address && formData.locality && formData.city && formData.state) {
      isValid = true;
      setIsFormValid(isValid);
    }
  }, [formData.address, formData.state, formData.locality, name, mobile, Pin]);
  console.log("formIsValid", isFormValid);
  var startTimer = useCallback(function () {
    interval = setInterval(function () {
      if (timeLeftToResend >= 1) {
        setTimeLeftToResend(function (prevState) {
          return prevState - 1;
        });
      } else if (timeLeftToResend < 1) {
        setTimeLeftToResend(0);
      }
    }, 1000);
  }, [timeLeftToResend]);
  useEffect(function () {
    if (timeLeftToResend < 1 && interval) {
      clearInterval(interval);
    }
    if (timeLeftToResend === 59) {
      if (interval) {
        clearInterval(interval);
      }
      startTimer();
    }
  }, [timeLeftToResend]);
  useEffect(function () {
    // Function to update cart count from localStorage
    var updateCartCount = function updateCartCount() {
      if (isPoints ? localStorage.getItem("cartData_reloyrewardpoints") : localStorage.getItem("cartData")) {
        var cartData = isPoints ? JSON.parse(localStorage.getItem("cartData_reloyrewardpoints")) : JSON.parse(localStorage.getItem("cartData"));
        setCartAmount(cartData ? cartData.totalMrp : 0);
        setCartItems(cartData ? cartData.totalProduct : 0);
        setShippingFee(cartData ? cartData.totalShippingFee : 0);
        setCartPoint(cartData ? cartData.totalPoints : 0);
        setPlatformFee(cartData ? 99 : 0);
        getOffers();
        if (cartData.totalMrp > 0) {
          setCartValue(cartData.cartValues);
          console.log("cartVa", cartValue);
        } else {
          clearCartvalue();
        }
      } else {
        clearCartvalue();
      }
    };

    // Initial count load
    updateCartCount();

    // Listen for the custom 'cartUpdated' event
    window.addEventListener("cartUpdated", updateCartCount);

    // Cleanup event listener on component unmount
    return function () {
      window.removeEventListener("cartUpdated", updateCartCount);
    };
  }, []);
  var clearCartvalue = function clearCartvalue() {
    setCartAmount(0);
    setCartValue([]);
    setShippingFee(0);
    setPlatformFee(0);
    history.push(isPoints ? "/rewardpointstore" : "/rewardStore");
  };
  var handleSubmit = function handleSubmit() {
    setLoading(true);
    console.log(formData);
    // const otpString = otp.join('');

    var dealIds = cartValue.map(function (deal) {
      return deal.id;
    }).join(",");
    var pointsRedeemed = cartValue.reduce(function (total, deal) {
      return total + deal.points;
    }, 0);
    var rewardTypeParam = appType === "winnre" || isPoints ? "&rewardType=RELOY_REWARDS" : "&rewardType=REFERRAL_REWARDS";
    var alternateMobileParam = phoneNumber ? "&alternateMobileNumber=".concat(phoneNumber) : '';
    winnreAuth === null || winnreAuth === void 0 || winnreAuth({
      method: "POST",
      url: "/winnre/user/deals/reward-redeem?otp=".concat(otp, "&dealIds=").concat(dealIds, "&pointsRedeemed=").concat(pointsRedeemed, "&mobileNumber=").concat(getMobileWithoutCountryCode(), "&amountToBePaid=").concat(shippingFee + 99, "&customerName=").concat(name, "&countryCode=").concat(country.dialCode).concat(alternateMobileParam).concat(rewardTypeParam),
      data: {
        address: formData.address,
        city: formData.city,
        country: "India",
        line1: formData.address,
        line2: formData.address,
        streetAddress: "",
        microMarket: "",
        pincode: Pin,
        subregion: formData.locality,
        state: formData.state
      }
    }).then(function (res) {
      var _window;
      // setStatus(true);
      (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("RewardsOTPSubmitted", {
        Status: res.status
      });
      console.log("Resp", res);
      setLoading(false);
      if (res.status === "SUCCESS") {
        // window?.webengage?.track('PaymentGatewayInvoked', {
        //     DealID: deal?.id,
        //     Amount: amountPayable,
        //     PointsRedeemed: points,
        //     OfferName: deal?.title,
        //     BrandName: deal?.vendor?.name,
        //     Category: deal?.category?.name,
        //     Tags: `${deal?.tags?.map((tag) => tag?.name)}`
        // });
        setRedirecting(true);
        window.location.href = res.message;
        if (isPoints) {
          localStorage.removeItem("cartData_reloyrewardpoints");
        } else {
          localStorage.removeItem("cartData");
        }
      } else {
        setError(res === null || res === void 0 ? void 0 : res.message);
      }
    })["catch"](function (err) {
      console.log(err);
      setError("Something went wrong. Please try again");
    });
  };
  var getConditionalStep = function getConditionalStep() {
    switch (currentStep) {
      case 1:
        return /*#__PURE__*/_jsx(Bag, {
          cartValue: cartValue,
          redux: redux,
          isPoints: isPoints
        });
      case 2:
        return /*#__PURE__*/_jsx(Address, {
          cartValue: cartValue,
          formData: formData,
          setFormData: setFormData,
          name: name,
          nameChangedHandler: nameChangedHandler,
          nameBlurHandler: nameBlurHandler,
          nameHasError: nameHasError,
          nameIsValid: nameIsValid,
          Pin: Pin,
          PinChangedHandler: PinChangedHandler,
          PinHasError: PinHasError,
          PinBlurHandler: PinBlurHandler,
          PinIsValid: PinIsValid,
          phoneNumber: phoneNumber,
          phoneChangedHandler: phoneChangedHandler,
          phoneBlurHandler: phoneBlurHandler,
          phoneHasError: phoneHasError,
          phoneNumberIsValid: phoneNumberIsValid,
          mobileNumberIsValid: mobileNumberIsValid,
          mobile: mobile,
          setMobile: setMobile,
          mobileHasError: mobileHasError,
          onChange: onChange,
          validator: validator,
          setIsTouched: setIsTouched,
          setInputFocused: setInputFocused
        });
      default:
        return /*#__PURE__*/_jsx(Bag, {
          cartValue: cartValue,
          redux: redux,
          isPoints: isPoints
        })
        // <Address
        //     deal={deal}
        //     formData={formData}
        //     setFormData={setFormData}
        //     name={name}
        //     nameChangedHandler={nameChangedHandler}
        //     nameBlurHandler={nameBlurHandler}
        //     nameHasError={nameHasError}
        //     nameIsValid={nameIsValid}
        //     Pin={Pin}
        //     PinChangedHandler={PinChangedHandler}
        //     PinHasError={PinHasError}
        //     PinBlurHandler={PinBlurHandler}
        //     PinIsValid={PinIsValid}
        //     phoneNumber={phoneNumber}
        //     phoneChangedHandler={phoneChangedHandler}
        //     phoneBlurHandler={phoneBlurHandler}
        //     phoneHasError={phoneHasError}
        //     phoneNumberIsValid={phoneNumberIsValid}
        //     mobileNumberIsValid={mobileNumberIsValid}
        //     mobile={mobile}
        //     setMobile={setMobile}
        //     mobileHasError={mobileHasError}
        //     onChange={onChange}
        //     validator={validator}
        //     setIsTouched={setIsTouched}
        //     setInputFocused={setInputFocused}
        // />
;
    }
  };
  var handleBackClick = function handleBackClick() {
    if (currentStep === 2) {
      setCurrentStep(1);
    } else {
      history.goBack();
    }
    // history.goBack();
  };
  var handleTermsClick = function handleTermsClick() {
    history.push("/terms-and-conditions", {
      scrollTo: "rewardsTerms"
    });
  };
  var placeOrder = function placeOrder() {
    var _window2;
    (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.webengage) === null || _window2 === void 0 || _window2.track("PlaceOrderClicked", {
      CartTotal: "".concat(cartAmount),
      Quantity: "".concat(cartItems),
      PlatformFee: "99",
      ShippingFee: "".concat(shippingFee),
      AmountPayable: "".concat(shippingFee + 99)
    });
    setCurrentStep(currentStep + 1);
  };
  var formattedCartPoint = Number(cartPoint || 0).toLocaleString("en-IN");
  console.log("CART POINTS", cartPoint);
  return /*#__PURE__*/_jsxs("div", {
    className: "".concat(showAppDownload ? "pb-24" : "pb-8"),
    children: [/*#__PURE__*/_jsxs("div", {
      className: " mt-4 lg:mt-8",
      children: [/*#__PURE__*/_jsx("div", {
        onClick: handleBackClick,
        className: "flex items-start pl-4 lg:pl-10 cursor-pointer ",
        children: /*#__PURE__*/_jsx(BsArrowLeft, {
          className: "text-black w-6 h-full"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "flex justify-center items-center mb-8 mt-2 lg:-mt-7",
        children: /*#__PURE__*/_jsxs("h1", {
          className: " text-base md:text-lg font-semibold tracking-wide text-gray-600",
          children: [/*#__PURE__*/_jsx("span", {
            className: currentStep === 1 ? "text-primary" : "font-bold text-black",
            children: "SHOPPING CART"
          }), /*#__PURE__*/_jsx("span", {
            className: "mx-3 text-gray-400",
            children: "----------"
          }), /*#__PURE__*/_jsx("span", {
            className: currentStep === 2 ? "text-primary" : currentStep > 2 ? "font-bold text-black" : "text-[#908F95]",
            children: "CHECKOUT"
          })]
        })
      })]
    }), !loadingDeal && currentStep != 1 && /*#__PURE__*/_jsx("div", {
      className: "flex flex-col items-center ",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col gap-2 justify-between w-[90%] lg:w-[60%] max-w-6xl px-4 lg:py-4 pb-2 mb-4  pb-6 border-2 border-gray-200 rounded-lg shadow-sm",
        children: [/*#__PURE__*/_jsx("h1", {
          className: "font-bold text-base",
          children: "Product Details"
        }), /*#__PURE__*/_jsx("div", {
          className: "".concat((cartValue === null || cartValue === void 0 ? void 0 : cartValue.length) > 3 && "grid md:grid-cols-2 md:gap-x-10", " max-h-[30vh] overflow-y-scroll scrollbar-thin lg:scrollbar-hide "),
          children: cartValue.map(function (deal, index) {
            return /*#__PURE__*/_jsxs("div", {
              className: "flex flex-row gap-6 lg:items-center pt-4 py-2 lg:py-4 border-b border-gray-200",
              children: [/*#__PURE__*/_jsx("img", {
                className: "w-24 h-24 lg:w-20 lg:h-20 object-cover "
                // src={deal?.displayImage?.url}
                ,
                src: deal !== null && deal !== void 0 && deal.thumbnailImageUrl ? deal === null || deal === void 0 ? void 0 : deal.thumbnailImageUrl : deal === null || deal === void 0 ? void 0 : deal.displayImageUrl
              }), /*#__PURE__*/_jsxs("div", {
                className: "flex flex-col gap-2",
                children: [/*#__PURE__*/_jsx("div", {
                  className: "flex items-center",
                  children: /*#__PURE__*/_jsx("div", {
                    children: /*#__PURE__*/_jsx("h4", {
                      className: "text-sm font-bold",
                      children: deal === null || deal === void 0 ? void 0 : deal.title
                    })
                  })
                }), /*#__PURE__*/_jsx("div", {
                  className: "flex items-center gap-3",
                  children: /*#__PURE__*/_jsx("p", {
                    className: "text-primary text-base font-bold",
                    children: isPoints ? "".concat(Number((deal === null || deal === void 0 ? void 0 : deal.points) || 0).toLocaleString("en-IN"), " Points") : toIndianRs(deal === null || deal === void 0 ? void 0 : deal.productMrp)
                  })
                })]
              })]
            });
          })
        })]
      })
    }),
    /*#__PURE__*/
    /* !loadingDeal && */
    _jsxs("div", {
      className: "flex flex-col items-center ",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex lg:flex-row  flex-col justify-between w-[90%] lg:w-[60%] max-w-6xl px-4 lg:py-4 pt-2  pb-6 border-2 border-gray-200 rounded-lg shadow-sm",
        children: [/*#__PURE__*/_jsx("div", {
          className: "lg:w-[50%] w-full",
          children: getConditionalStep()
        }), /*#__PURE__*/_jsx("div", {
          className: "lg:border-l-2 border-b-2 border-gray-200 -mx-4 lg:mx-0 lg:-my-4"
        }), currentStep === 1 && /*#__PURE__*/_jsxs("div", {
          className: "lg:w-[40%] w-full",
          children: [/*#__PURE__*/_jsx("h1", {
            className: "font-bold text-lg mt-4 lg:mt-0 pb-2",
            children: "Product Details"
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex justify-between text-sm mb-2",
            children: [/*#__PURE__*/_jsx("h4", {
              className: "text-[#908F95]",
              children: isPoints ? "Total Points" : "Total MRP"
            }), /*#__PURE__*/_jsx("h4", {
              className: "font-medium text-sm ".concat(isPoints ? "" : "line-through"),
              children: isPoints ? formattedCartPoint : toIndianRs(cartAmount)
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex justify-between text-sm mb-2",
            children: [/*#__PURE__*/_jsxs("h4", {
              className: "text-[#908F95]",
              children: ["Selling Price", " "]
            }), /*#__PURE__*/_jsx("h4", {
              className: "text-green-500 text-sm font-semibold",
              children: toIndianRs(99)
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex justify-between text-sm mb-2",
            children: [/*#__PURE__*/_jsx("h4", {
              className: "text-[#908F95]",
              children: "Shipping Fee "
            }), shippingFee > 0 && /*#__PURE__*/_jsx("h4", {
              className: "text-green-500 text-sm font-semibold",
              children: toIndianRs(shippingFee)
            }), shippingFee === 0 && /*#__PURE__*/_jsx("h4", {
              className: "text-green-500 text-sm font-semibold",
              children: "FREE"
            })]
          }), /*#__PURE__*/_jsx("hr", {
            className: "mx-4 my-4 border-b-[2px] border-gray-100"
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex justify-between font-bold mt-4",
            children: [/*#__PURE__*/_jsx("h4", {
              children: "Amount Payable"
            }), /*#__PURE__*/_jsx("h4", {
              children: toIndianRs(shippingFee + 99)
            })]
          }), /*#__PURE__*/_jsx("button", {
            className: " bg-blue-600 hover:bg-blue-700 text-white w-full py-3 rounded mt-6 cursor-pointer ",
            onClick: placeOrder,
            children: "Place Order"
          })]
        }), currentStep != 1 && /*#__PURE__*/_jsx("div", {
          className: "lg:w-[40%] w-full",
          children: /*#__PURE__*/_jsx("div", {
            className: "flex flex-col gap-4",
            children: /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("h1", {
                className: "font-bold text-base mb-4 mt-4 lg:mt-0",
                children: "Payment Details"
              }), /*#__PURE__*/_jsxs("div", {
                className: "flex justify-between mb-2",
                children: [/*#__PURE__*/_jsx("h4", {
                  className: "text-[#908F95] text-sm",
                  children: isPoints ? "Total Points" : "Total MRP"
                }), /*#__PURE__*/_jsx("h4", {
                  className: "font-medium text-sm ".concat(isPoints ? "" : "line-through"),
                  children: isPoints ? formattedCartPoint : toIndianRs(cartAmount)
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: "flex justify-between text-sm mb-2",
                children: [/*#__PURE__*/_jsxs("h4", {
                  className: "text-[#908F95] text-sm",
                  children: ["Selling Price", " "]
                }), /*#__PURE__*/_jsx("h4", {
                  className: "text-green-500 text-sm font-semibold",
                  children: toIndianRs(99)
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: "flex justify-between text-sm mb-2",
                children: [/*#__PURE__*/_jsx("h4", {
                  className: "text-[#908F95]",
                  children: "Shipping Fee "
                }), shippingFee > 0 && /*#__PURE__*/_jsx("h4", {
                  className: "text-green-500 text-sm font-semibold",
                  children: toIndianRs(shippingFee)
                }), shippingFee === 0 && /*#__PURE__*/_jsx("h4", {
                  className: "text-green-500 text-sm font-semibold",
                  children: "FREE"
                })]
              }), /*#__PURE__*/_jsx("hr", {
                className: "mx-4 my-4 border-b-[2px] border-gray-100"
              }), /*#__PURE__*/_jsxs("div", {
                className: "flex justify-between font-bold mt-4",
                children: [/*#__PURE__*/_jsx("h4", {
                  children: "Amount Payable"
                }), /*#__PURE__*/_jsx("h4", {
                  children: toIndianRs(shippingFee + 99)
                })]
              }), currentStep === 2 && /*#__PURE__*/_jsx(LoadingButton, {
                disabled: currentStep === 2 && !isFormValid,
                className: " bg-[#16519E] text-white w-full py-3 rounded mt-6 cursor-pointer\n                   ".concat(currentStep === 2 && !isFormValid ? "bg-blue-600 text-white opacity-75 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700", "  "),
                onClick: getOtp,
                loading: otpLoading && currentStep === 2,
                children: "Proceed to Checkout"
              }), /*#__PURE__*/_jsx("p", {
                className: "mt-1 text-sm",
                children: "Once you redeem, your item will be processed for delivery within 10 business days based on your location"
              })]
            })
          })
        })]
      }), currentStep === 1 && /*#__PURE__*/_jsx(_Fragment, {
        children: isPoints ? (userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.reloyRewardPoints) > cartPoint && (deals === null || deals === void 0 ? void 0 : deals.length) > 0 : (userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.rewardPoints) + (userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.unInvoicedCommission) > cartPoint && (deals === null || deals === void 0 ? void 0 : deals.length) > 0 ? /*#__PURE__*/_jsxs("div", {
          className: "px-4 py-5 lg:p-5",
          children: [/*#__PURE__*/_jsxs("p", {
            className: "mb-4 mt-4 text-xl text-primary font-semibold px-1 lg:px-0",
            children: [" ", "You have more rewards to redeem"]
          }), deals.length > 0 && /*#__PURE__*/_jsx(DealSection, {
            type: " ",
            offers: deals.slice(0, 3),
            isRewards: true,
            isPoints: isPoints,
            config: config,
            redux: redux,
            router: router,
            cmsClient: cmsClient,
            winnreAuth: winnreAuth,
            winnreNoAuth: winnreNoAuth
          }), /*#__PURE__*/_jsx("button", {
            onClick: function onClick() {
              return history.push(isPoints ? "/rewardpointstore" : "/rewardStore");
            },
            className: "flex items-center justify-center gap-x-2 mx-auto px-4 py-2 text-[#908F95] border-[3px] border-[#DDDDDD] rounded mb-6 mt-8",
            children: "View More Rewards"
          })]
        }) : /*#__PURE__*/_jsx("div", {
          className: "w-full",
          children: /*#__PURE__*/_jsx(BasketFull, {
            isCheckout: true,
            placeOrder: placeOrder,
            redux: redux
          })
        })
      }), /*#__PURE__*/_jsxs(Modal, {
        visible: showOtpModal,
        className: "w-[98%] md:w-[50%] lg:w-[40%] xl:w-[30%]",
        children: [loading && !redirecting && /*#__PURE__*/_jsxs("div", {
          className: "h-[30vh] flex flex-col justify-center items-center py-1",
          children: [/*#__PURE__*/_jsx("div", {
            className: "",
            children: /*#__PURE__*/_jsx(LoadingButton, {
              hideButton: true,
              loading: loading
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "mt-4",
            children: /*#__PURE__*/_jsx("p", {
              className: "text-sm text-[#16519E] mt-2 leading-4 px-10 text-center",
              children: "Upon successful verification of the OTP, you will be redirected to a payment page powered by Reloy. Your order will be processed upon successful payment."
            })
          })]
        }), !loading && !redirecting && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "flex justify-end px-4 pt-6 cursor-pointer",
            children: /*#__PURE__*/_jsx(GrClose, {
              onClick: function onClick() {
                return setShowOtpModal(false);
              },
              className: " h-5 w-5 cursor-pointer "
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "flex flex-col pt-4 pb-8 justify-center",
            children: /*#__PURE__*/_jsxs("div", {
              className: " text-center",
              children: [/*#__PURE__*/_jsx("h2", {
                className: "text-xl font-bold mb-2",
                children: "Claim your Reward"
              }), /*#__PURE__*/_jsx("p", {
                className: "text-sm mt-2 mb-2 text-[#16519E]",
                children: "You are redeeming products against your referral rewards. Please note that once an order is placed, it cannot be canceled."
              }), /*#__PURE__*/_jsx("hr", {
                className: " w-1/2 h-1 bg-gray-300 my-4 mx-auto border-2"
              }), /*#__PURE__*/_jsxs("div", {
                className: "px-5",
                children: [/*#__PURE__*/_jsx("p", {
                  className: "text-gray-600 mb-6 px-3",
                  children: "Verify your mobile number to claim. We have sent an OTP to your registered mobile number/email."
                }), /*#__PURE__*/_jsx("div", {
                  className: " flex items-start mb-4",
                  children: /*#__PURE__*/_jsx("input", {
                    type: "text",
                    value: otp,
                    onChange: handleChange,
                    maxLength: "4",
                    autoComplete: "one-time-code",
                    inputMode: "numeric",
                    className: "w-full h-12 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-300 text-lg pl-2",
                    placeholder: "Enter OTP"
                  })
                }), /*#__PURE__*/_jsx("div", {
                  className: "flex items-start mb-4",
                  children: timeLeftToResend > 0 ? /*#__PURE__*/_jsxs("b", {
                    className: "",
                    children: ["Resend again in 00:", timeLeftToResend < 10 ? "0" + timeLeftToResend : timeLeftToResend]
                  }) : /*#__PURE__*/_jsx("b", {
                    className: "font-semibold cursor-pointer",
                    onClick: getOtp,
                    children: "Resend OTP ?"
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  className: "flex my-1",
                  children: [/*#__PURE__*/_jsx("input", {
                    type: "checkbox",
                    checked: termsCheckbox,
                    onChange: handleOnChange,
                    className: "checkbox-sm bg-white rounded-md border-gray-100 checked:bg-blue-600",
                    autoComplete: "off"
                  }), /*#__PURE__*/_jsxs("p", {
                    className: " mx-2 text-sm ",
                    children: [/*#__PURE__*/_jsx("span", {
                      children: "I agree to the"
                    }), /*#__PURE__*/_jsx("span", {
                      onClick: handleTermsClick,
                      className: "font-semibold text-primary cursor-pointer",
                      children: " Terms & Conditions"
                    })]
                  })]
                })]
              }), /*#__PURE__*/_jsx("div", {
                className: "px-5 mt-4 ",
                children: /*#__PURE__*/_jsx("button", {
                  onClick: handleSubmit,
                  className: "bg-[#16519E] text-white w-full py-2 rounded-md transition duration-200 ".concat(!termsCheckbox || otp.length < 4 ? "cursor-not-allowed opacity-50" : "cursor-pointer "),
                  disabled: !termsCheckbox || otp.length < 4,
                  children: "Submit"
                })
              }), /*#__PURE__*/_jsx("p", {
                className: "text-sm text-[#16519E] mt-1 leading-4 px-10",
                children: "Once your OTP is verified, you'll be redirected to the Reloy-powered payment page. Your order will be processed after successful payment."
              }), error && /*#__PURE__*/_jsx("div", {
                "class": "alert alert-error  mx-8 animate-pulse h-auto mt-2 ",
                children: /*#__PURE__*/_jsx("label", {
                  children: error
                })
              })]
            })
          })]
        })]
      })]
    })]
  });
}
export default Checkout;